import { Auth } from 'aws-amplify';
import React, { useEffect } from 'react';
import { useAlert } from 'react-alert';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import { useTranslation } from 'react-i18next';
import { getError } from 'utils/appHelpers';
import { getUserProfile, onSetAccount } from 'app/actions/authActions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

const VerifyEmail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const alert = useAlert();
  const url = new URL(window.location.href);
  const code = url.searchParams.get('param');

  const onVerifyEmail = async code => {
    try {
      const parts = code.split('/');
      let verificationCode = parts.length > 0 ? parts[0] : code;

      await Auth.verifyCurrentUserAttributeSubmit('email', verificationCode);
      alert.success(t('msg_sucess_email_verified'));
      const user = await getUserProfile();
      dispatch(onSetAccount({ ...user }));
    } catch (err) {
      alert.error(getError(err));
    } finally {
      history.push('/');
    }
  };

  useEffect(() => {
    onVerifyEmail(code);
  }, []);

  return <SkeletonLoader type='basic' count={3} />;
};

export default VerifyEmail;
